import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import { getFeedByUserId, actFeed } from "@/api/http/gx/gxFeed";
import { hitFollow, hitLike, hitComment } from "@/api/http/ins/insUser";
import store from "@/store/index";

let grandTotal: number = 0; //累计的次数
let requestFeedTime: number = 0; //再次请求feed的次数
const requestFeedMaxTime: number = 6; //最多的次数

const getLastOfferFeedIndex = (feeds: any) => {
  console.log("getLastOfferFeedIndex获取的feed:", feeds);
  let findFeedOfferIndex: any = null;
  for (let i = 0; i < feeds.length; i++) {
    if (feeds[i].kind === "offer") {
      findFeedOfferIndex = i;
    }
  }
  if (findFeedOfferIndex === null) {
    //没有找到,直接返回获取的长度
    return feeds.length;
  } else if (feeds.length - 1 - findFeedOfferIndex < 0) {
    return 0;
  } else {
    return feeds.length - 1 - findFeedOfferIndex;
  }
};

const insertFeeds = (remainIndex: number, feeds: any) => {
  let feedSpacing: number = 5;
  const { earn_limit } = store.getters[types.GETTER_SETTING_DATA];
  if (earn_limit && earn_limit.other_feed_spacing) {
    feedSpacing = earn_limit.other_feed_spacing;
  }
  const newFeeds = [...feeds];
  console.log("insertFeeds:", {
    remainIndex,
    feeds
  });
  if (remainIndex + newFeeds.length < feedSpacing) {
    console.log("小于" + feedSpacing + "个");
    return newFeeds;
  } else if (remainIndex + newFeeds.length === feedSpacing) {
    console.log("直接插入一个 =" + feedSpacing + "");
    //直接插入一个
    newFeeds.push(store.getters[types.GETTER_RANDOM_FEED_OFFER]());
    return newFeeds;
  } else {
    //大于5
    //TODO 可能刚好需要插入
    console.log("大于了feedSpacing:", feedSpacing);
    const newArr = [];
    let totalNum = remainIndex;
    for (const val of newFeeds) {
      totalNum += 1;
      if (totalNum === feedSpacing + 1) {
        // console.log("push:>>>", {
        //   i,
        //   totalNum
        // });
        newArr.push(store.getters[types.GETTER_RANDOM_FEED_OFFER]());
        totalNum = 0;
        continue;
      }
      newArr.push(val);
    }
    return newArr;
  }
};

const actions: ActionTree<any, any> = {
  async [types.INSERT_FEED_OFFER](
    { state, commit, dispatch, rootState, getters },
    payload: any
  ) {
    try {
      let feeds: any = [...payload];
      //判断是否支持权重：

      if (!getters[types.GETTER_EARN_COINS_GREEN_LIGHT]()) {
        //不支持权重
        console.log(
          "不支持权重:",
          getters[types.GETTER_EARN_COINS_GREEN_LIGHT]()
        );
        return feeds;
      }
      //需要判最后一个offer后面跟了几个普通feed:
      const lastOfferFeedIndex = getLastOfferFeedIndex(state.feeds);
      // console.log(
      //   "lastOfferFeedIndex后面跟了几个普通的feed:",
      //   lastOfferFeedIndex
      // );
      feeds = insertFeeds(lastOfferFeedIndex, feeds);
      console.log("insertFeeds:", feeds);
      return feeds;
    } catch (error) {
      console.error("INSERT_FEED_OFFER error:", error);
      return Promise.reject("");
    }
  },
  async [types.FILTER_FEEDS](
    { state, commit, dispatch, rootState },
    payload: any
  ) {
    let newFeeds = [...payload];
    //需要进行服务器下发的过滤，将offer的类型全部过滤掉:
    newFeeds = newFeeds.filter((feed: any) => {
      return !(feed.kind === "offer");
    });
    //需要第二步的过滤，将池子已经有的feed_id过滤掉:
    const { feeds } = state;
    newFeeds = newFeeds.filter((newFeed: any) => {
      for (const oldFeed of feeds) {
        if (oldFeed.feed_id === newFeed.feed_id) {
          // console.log("发现了重复的feeds:", oldFeed);
          return false;
        }
      }
      // console.log("没有发现重复的feeds", newFeed);
      return true;
    });
    return newFeeds;
  },
  async [types.REQUEST_FEEDS](
    { state, commit, dispatch, rootState },
    payload: any = "all"
  ) {
    try {
      let feeds: any = await getFeedByUserId(rootState.masterUserId, "", 1);
      feeds = await dispatch(types.FILTER_FEEDS, feeds);

      console.log("REQUEST_FEEDS:", feeds);

      //累加如果少于5个继续
      grandTotal += feeds.length;
      if (grandTotal <= 5) {
        requestFeedTime += 1;
        if (requestFeedTime <= requestFeedMaxTime) {
          console.log("requestFeedTime再次拉取:", requestFeedTime);
          dispatch(types.REQUEST_FEEDS);
        } else {
          console.log("requestFeedTime停止初始化:", requestFeedTime);
          requestFeedTime = 0;
        }
      } else {
        grandTotal = 0; //累计器清零
        requestFeedTime = 0;
      }

      feeds = await dispatch(types.INSERT_FEED_OFFER, feeds);
      commit(types.GET_FEEDS, feeds);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async [types.ACT_FEED](
    { state, commit, dispatch, rootState, getters },
    payload: any
  ) {
    try {
      const actFeedProcess: any = async (userData: any) => {
        //账号的计数显示：
        dispatch(types.ACCOUNT_LIMIT_PROCESS, {
          feed: payload,
          user: userData
        });

        //执行ins的请求，请求成功后执行gx请求:
        if (payload.sub_kind === "follow") {
          for (const feed of payload.subresources) {
            hitFollow(userData.userId, feed.user_id)
              .then((result: any) => {
                // console.log("hitFollow result:", result);
                actFeed(
                  rootState.masterUserId.toString(),
                  userData.userId.toString(),
                  result.status,
                  result.message,
                  feed.kind,
                  feed.user_id
                )
                  .then(res => {
                    // console.log("actFeed hitFollow result:", res);
                    dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, res);
                  })
                  .catch(err => {});
              })
              .catch(err => {
                console.log("hitFollow err:", err);
              });
          }
        } else if (payload.sub_kind === "like") {
          for (const feed of payload.subresources) {
            hitLike(userData.userId, feed.media_id)
              .then((result: any) => {
                console.log("hitLike result:", result);
                actFeed(
                  rootState.masterUserId.toString(),
                  userData.userId.toString(),
                  result.status,
                  result.message,
                  feed.kind,
                  feed.media_id
                )
                  .then(res => {
                    console.log("actFeed hitLike result:", res);
                    dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, res);
                  })
                  .catch(err => {});
              })
              .catch(err => {
                console.log("hitLike err:", err);
              });
          }
        } else if (payload.sub_kind === "comment") {
          for (const feed of payload.subresources) {
            hitComment(userData.userId, feed.media_id, feed.comment.content)
              .then((result: any) => {
                console.log("hitComment result:", result);
                actFeed(
                  rootState.masterUserId.toString(),
                  userData.userId.toString(),
                  result.status,
                  result.message,
                  feed.kind,
                  feed.media_id
                )
                  .then(res => {
                    console.log("actFeed hitComment result:", res);
                    dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, res);
                  })
                  .catch(err => {});
              })
              .catch(err => {
                console.log("hitComment err:", err);
              });
          }
        }
      };

      //判断如果payload不合法
      if (!payload) {
        return;
      }

      //获取到可用的用户：
      const workingUserList = getters[types.GETTER_EARN_COIN_USER_LIST](
        "working"
      );
      console.log("获取到了workingUserList:", workingUserList);

      const checkResult = await dispatch(types.EARN_COINS_CHECK, {
        feed: payload
      });
      console.log("checkResult:", checkResult);

      if (!checkResult) {
        return Promise.reject("checkResult false");
      }

      const gxSignCheck = await dispatch(types.CHECK_GX_USER_LOGINED);
      if (!gxSignCheck) {
        return Promise.reject("checkGxSign false");
      }

      commit(types.ACT_FEED); //state shift();
      //检查账号的各类状态，以及他的限制

      for (const user of workingUserList) {
        actFeedProcess(user);
      }

      if (state.feeds.length < 5) {
        //如果少于5个提前拉取feeds流
        dispatch(types.REQUEST_FEEDS);
      }
    } catch (error) {
      console.log("ACT_FEED eror:", error);
      return Promise.reject(error);
    }
  },
  async [types.SKIP_FEED](
    { state, commit, dispatch, rootState },
    payload: any
  ) {
    try {
      commit(types.SKIP_FEED);
      if (state.feeds.length < 5) {
        dispatch(types.REQUEST_FEEDS);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default actions;
